export default {"src":"/_next/static/media/icon-mail.70a964fb.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};